<template>
  <ValidationProvider ref="mobileProvider" name="mobile" rules="required|numeric|mobile"
    v-slot="{ errors }">
    <label v-if="index != -1" class="pb-2">{{ label }}</label>
    <v-text-field ref="inputRef" solo type="text" maxlength="10" inputmode="number" placeholder="Ex:05xxxxxxxx"
      v-bind="$attrs" @change="onChange($event)" @input="onInput($event)" @keydown="onKeydown($event)"
      :error-messages="errors">
    </v-text-field>
    <span style="color:#f75555" v-if="duplicateMsg">{{ duplicateMsg }}</span>
  </ValidationProvider>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { moduleProxy } from '@/store';
import { TarafTypeEnum } from '@/enums/tarafTypeEnum';
import { Regex } from '@/utils/regex';
import { Utils } from '@/utils/utils';

@Component
export default class MobileComponent extends Vue {
  @Prop({ default: '' }) inputValue!: string;
  @Prop({ default: -1 }) index!: number;
  @Prop({ default: '' }) label!: string;
  @Prop({ default: false }) isCheckDuplicate!: boolean;
  duplicateMsg = '';

  mounted() {
    if (this.isCheckDuplicate) {
      this.checkIfMobileDuplicated(this.inputValue);
    }
  }

  onKeydown(event: KeyboardEvent): void {
    Utils.AllowDigitsKeys(event);
  }

  onChange(value: string): void {
    if (!Regex.Numbers.test(value)) {
      (this.$refs.inputRef as any).reset();
      return;
    }

    if (this.isCheckDuplicate) {
      this.checkIfMobileDuplicated(value);
    }
  }

  async onInput(value: string): Promise<void> {
    const result = await (this.$refs.mobileProvider as any).validate(value);
    this.$emit('input', value);
    this.$emit('update:inputValue', value);

    if (this.index !== -1) {
      this.$emit('controlDataChanged', { value, index: this.index, isValid: result.valid });
    }
  }

  private checkIfMobileDuplicated(value: string): void {
    this.duplicateMsg = '';
    const partner = moduleProxy.Contract.getContractPartners.find((x) => x.mobileNumber === value);

    if (partner) {
      if (partner.partnerTarafTypeId === TarafTypeEnum.FirstPartner) {
        this.duplicateMsg = 'عذرًا، رقم الجوال المدخل غير صحيح يجب ألا يطابق رقم جوال الطرف الأول';
      } else if (partner.partnerTarafTypeId === TarafTypeEnum.SecondPartner) {
        this.duplicateMsg = 'عذرًا، رقم الجوال المدخل غير صحيح يجب ألا يطابق رقم جوال الطرف الثاني';
      } else {
        this.duplicateMsg = 'عذرًا، رقم الجوال المدخل غير صحيح يجب ألا يطابق رقم جوال المحامي';
      }
    }

    this.$emit('mobileDuplicationValidated', this.duplicateMsg);
  }
}
</script>
